// Spreadsheet ID for Harvard COVID data
export const HARVARD_COVID_URL = "1pJUpky9QRHA2tcaNMgS3gjq4pjrlUnjMZ2stXsaMOB0";

// URL for johns hopkins university COVID data
export const JHU_COVID_URL = "https://corona.lmao.ninja/v2/";
